var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Business / profile-fill",
    clipPath: "url(#clip0_12076_626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.66797 3.993C2.6698 3.73038 2.77487 3.47902 2.96048 3.29322C3.14609 3.10742 3.39735 3.00209 3.65997 3H21.676C22.224 3 22.668 3.445 22.668 3.993V20.007C22.6661 20.2696 22.5611 20.521 22.3755 20.7068C22.1898 20.8926 21.9386 20.9979 21.676 21H3.65997C3.39678 20.9997 3.14447 20.895 2.95846 20.7088C2.77245 20.5226 2.66797 20.2702 2.66797 20.007V3.993ZM6.66797 15V17H18.668V15H6.66797ZM6.66797 7V13H12.668V7H6.66797ZM14.668 7V9H18.668V7H14.668ZM14.668 11V13H18.668V11H14.668ZM8.66797 9H10.668V11H8.66797V9Z",
    fill: "#7B61FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12076_626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.667969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileFill);
export default __webpack_public_path__ + "static/media/profile-fill.908e4783869f6650f6bc191babd874ac.svg";
export { ForwardRef as ReactComponent };